// extracted by mini-css-extract-plugin
module.exports = {"profileItem":"minipProfile_profileItem__1_Ncb","name":"minipProfile_name__9dylm","lastChild":"minipProfile_lastChild__383Lo"};